import { getLocation } from '~/utils/window';

const HEALTHY_RESPONSE = 'pong';
const ERROR_MESSAGE =
  'Healthcheck error requested at /health-check?healthy=false';

const Healthcheck = () => {
  const { search } = getLocation();
  const hasError = search.includes('false');

  if (hasError) {
    throw new Error(ERROR_MESSAGE);
  }
  return <>{HEALTHY_RESPONSE}</>;
};

export default Healthcheck;
